import {
  ArrowDown as IconArrowDown,
  ArrowDownLeft as IconArrowDownLeft,
  ArrowDownRight as IconArrowDownRight,
  ArrowLeft as IconArrowLeft,
  ArrowRight as IconArrowRight,
  ArrowRightLeft as IconArrowRightLeft,
  ArrowUp as IconArrowUp,
  ArrowUpRight as IconArrowUpRight,
  BadgeCheck as IconBadgeCheck,
  Ban as IconBan,
  Landmark as IconBank,
  Banknote as IconBanknote,
  BanknoteArrowUp as IconBanknoteArrowUp,
  BanknoteX as IconBanknoteX,
  Barcode as IconBarcode,
  Bell as IconBell,
  BicepsFlexed as IconBicepsFlexed,
  Box as IconBox,
  BriefcaseBusiness as IconBriefcaseBusiness,
  Brush as IconBrush,
  Calculator as IconCalculator,
  Calendar as IconCalendar,
  ChartColumnBig as IconChartColumnBig,
  ChartNoAxesColumn as IconChartNoAxesColumn,
  ChartNoAxesColumnIncreasing as IconChartNoAxesColumnIncreasing,
  ChartPie as IconChartPie,
  Check as IconCheck,
  ChevronDown as IconChevronDown,
  ChevronLeft as IconChevronLeft,
  ChevronRight as IconChevronRight,
  ChevronsRight as IconChevronsRight,
  ChevronsUpDown as IconChevronsUpDown,
  ChevronUp as IconChevronUp,
  CircleAlert as IconCircleAlert,
  CircleCheck as IconCircleCheck,
  CircleDashed as IconCircleDashed,
  CirclePlus as IconCirclePlus,
  CircleQuestionMark as IconCircleQuestionMark,
  CircleSlash as IconCircleSlash,
  CircleX as IconCircleX,
  Clock as IconClock,
  ClockAlert as IconClockAlert,
  Coins as IconCoins,
  Columns3 as IconColumns,
  Columns3Cog as IconColumnsCog,
  ContactRound as IconContactRound,
  Copy as IconCopy,
  CreditCard as IconCreditCard,
  Download as IconDownload,
  Ellipsis as IconEllipsis,
  Euro as IconEuro,
  Eye as IconEye,
  EyeOff as IconEyeOff,
  File as IconFile,
  FileChartColumn as IconFileChartColumn,
  FileCheck as IconFileCheck,
  FileCode2 as IconFileCode,
  FileKey as IconFileKey,
  FilePen as IconFilePen,
  FilePenLine as IconFilePenLine,
  FilePlusCorner as IconFilePlusCorner,
  Files as IconFiles,
  FileSpreadsheet as IconFileSpreadsheet,
  FileText as IconFileText,
  FileXCorner as IconFileXCorner,
  Folder as IconFolder,
  FolderInput as IconFolderInput,
  FolderOutput as IconFolderOutput,
  Funnel as IconFunnel,
  Globe as IconGlobe,
  GripVertical as IconGripVertical,
  HandCoins as IconHandCoins,
  Hourglass as IconHourglass,
  Image as IconImage,
  Import as IconImport,
  Infinity as IconInfinity,
  Info as IconInfo,
  IterationCw as IconIteration,
  Laugh as IconLaugh,
  Layers as IconLayers,
  Lightbulb as IconLightbulb,
  Link as IconLink,
  ListChecks as IconListChecks,
  ListFilter as IconListFilter,
  ListOrdered as IconListOrdered,
  LoaderCircle as IconLoaderCircle,
  LoaderPinwheel as IconLoaderPinwheel,
  LockKeyhole as IconLockKeyhole,
  LockKeyholeOpen as IconLockKeyholeOpen,
  LogOut as IconLogout,
  Mail as IconMail,
  Mailbox as IconMailbox,
  MailCheck as IconMailCheck,
  MailOpen as IconMailOpen,
  Maximize as IconMaximize,
  Maximize2 as IconMaximize2,
  Menu as IconMenu,
  MessageCircle as IconMessageCircle,
  MessageCircleMore as IconMessageCircleMore,
  MessagesSquare as IconMessagesSquare,
  Minimize as IconMinimize,
  Minimize2 as IconMinimize2,
  Minus as IconMinus,
  MousePointerClick as IconMousePointerClick,
  Network as IconNetwork,
  NotepadText as IconNotepadText,
  Paperclip as IconPaperclip,
  PartyPopper as IconPartyPopper,
  PauseCircle as IconPause,
  Pencil as IconPencil,
  Percent as IconPercent,
  Phone as IconPhone,
  PiggyBank as IconPiggyBank,
  PlayCircle as IconPlay,
  Plug as IconPlug,
  Plus as IconPlus,
  Presentation as IconPresentation,
  Printer as IconPrinter,
  Puzzle as IconPuzzle,
  ReceiptEuro as IconReceiptEuro,
  ReceiptText as IconReceiptText,
  RefreshCw as IconRefresh,
  RefreshCwOff as IconRefreshCwOff,
  Repeat2 as IconRepeat2,
  Rocket as IconRocket,
  RotateCwSquare as IconRotateSquare,
  Search as IconSearch,
  SendHorizontal as IconSendHorizontal,
  Settings as IconSettings,
  Share2 as IconShare,
  Shield as IconShield,
  ShoppingBag as IconShoppingBag,
  Smartphone as IconSmartphone,
  Sparkle as IconSparkle,
  Sparkles as IconSparkles,
  SquareArrowOutUpRight as IconSquareArrowOutUpRight,
  SquareCheck as IconSquareCheck,
  SquarePen as IconSquarePen,
  SquarePlay as IconSquarePlay,
  Star as IconStar,
  Store as IconStore,
  SunDim as IconSunDim,
  Target as IconTarget,
  TextSelect as IconTextSelect,
  ThumbsDown as IconThumbsDown,
  ThumbsUp as IconThumbsUp,
  Trash2 as IconTrash,
  TriangleAlert as IconTriangleAlert,
  Undo2 as IconUndo,
  Unlink as IconUnlink,
  Unplug as IconUnplug,
  Upload as IconUpload,
  UploadCloud as IconUploadCloud,
  UserLock as IconUserLock,
  UserRound as IconUserRound,
  UsersRound as IconUsersRound,
  UserStar as IconUserStar,
  Wallet as IconWallet,
  Wrench as IconWrench,
  X as IconX,
  Zap as IconZap,
  ZoomIn as IconZoomIn,
  ZoomOut as IconZoomOut,
} from 'lucide-react'

import { ReactComponent as IconClockArrowUp } from '../../assets/icons/icon-clock-arrow-up.svg'

/* Keep */
import { ReactComponent as IconPaperPlane } from '../../assets/icons/icon-paper-plane.svg'
import { ReactComponent as IconPaypal } from '../../assets/icons/icon-paypal.svg'
import { ReactComponent as IconSparkleOrbit } from '../../assets/icons/icon-sparkle-orbit.svg'

export const iconToComponent = {
  arrowDown: IconArrowDown,
  arrowDownLeft: IconArrowDownLeft,
  arrowDownRight: IconArrowDownRight,
  arrowLeft: IconArrowLeft,
  arrowRight: IconArrowRight,
  arrowRightLeft: IconArrowRightLeft,
  arrowUp: IconArrowUp,
  arrowUpRight: IconArrowUpRight,
  badgeCheck: IconBadgeCheck,
  ban: IconBan,
  bank: IconBank,
  banknote: IconBanknote,
  banknoteArrowUp: IconBanknoteArrowUp,
  banknoteX: IconBanknoteX,
  barcode: IconBarcode,
  bell: IconBell,
  box: IconBox,
  bicepsFlexed: IconBicepsFlexed,
  briefcaseBusiness: IconBriefcaseBusiness,
  brush: IconBrush,
  calculator: IconCalculator,
  calendar: IconCalendar,
  chartColumnBig: IconChartColumnBig,
  chartNoAxesColumn: IconChartNoAxesColumn,
  chartNoAxesColumnIncreasing: IconChartNoAxesColumnIncreasing,
  chartPie: IconChartPie,
  check: IconCheck,
  chevronDown: IconChevronDown,
  chevronLeft: IconChevronLeft,
  chevronRight: IconChevronRight,
  chevronsRight: IconChevronsRight,
  chevronUp: IconChevronUp,
  chevronsUpDown: IconChevronsUpDown,
  circleAlert: IconCircleAlert,
  circleCheck: IconCircleCheck,
  circleDashed: IconCircleDashed,
  circlePlus: IconCirclePlus,
  circleQuestionMark: IconCircleQuestionMark,
  circleSlash: IconCircleSlash,
  circleX: IconCircleX,
  clock: IconClock,
  clockAlert: IconClockAlert,
  clockArrowUp: IconClockArrowUp,
  coins: IconCoins,
  columns: IconColumns,
  columnsCog: IconColumnsCog,
  contactRound: IconContactRound,
  copy: IconCopy,
  creditCard: IconCreditCard,
  download: IconDownload,
  ellipsis: IconEllipsis,
  eye: IconEye,
  eyeOff: IconEyeOff,
  euro: IconEuro,
  file: IconFile,
  fileChartColumn: IconFileChartColumn,
  fileCheck: IconFileCheck,
  fileCode: IconFileCode,
  fileKey: IconFileKey,
  filePen: IconFilePen,
  filePenLine: IconFilePenLine,
  filePlusCorner: IconFilePlusCorner,
  fileXCorner: IconFileXCorner,
  files: IconFiles,
  fileSpreadsheet: IconFileSpreadsheet,
  fileText: IconFileText,
  folder: IconFolder,
  folderInput: IconFolderInput,
  folderOutput: IconFolderOutput,
  funnel: IconFunnel,
  globe: IconGlobe,
  gripVertical: IconGripVertical,
  handCoins: IconHandCoins,
  hourglass: IconHourglass,
  image: IconImage,
  import: IconImport,
  infinity: IconInfinity,
  info: IconInfo,
  iteration: IconIteration,
  laugh: IconLaugh,
  layers: IconLayers,
  lightbulb: IconLightbulb,
  link: IconLink,
  listChecks: IconListChecks,
  listFilter: IconListFilter,
  listOrdered: IconListOrdered,
  loaderCircle: IconLoaderCircle,
  loaderPinwheel: IconLoaderPinwheel,
  lockKeyhole: IconLockKeyhole,
  lockKeyholeOpen: IconLockKeyholeOpen,
  logout: IconLogout,
  mail: IconMail,
  mailbox: IconMailbox,
  mailCheck: IconMailCheck,
  mailOpen: IconMailOpen,
  maximize: IconMaximize,
  maximize2: IconMaximize2,
  menu: IconMenu,
  messageCircle: IconMessageCircle,
  messageCircleMore: IconMessageCircleMore,
  messagesSquare: IconMessagesSquare,
  minimize: IconMinimize,
  minimize2: IconMinimize2,
  minus: IconMinus,
  mousePointerClick: IconMousePointerClick,
  network: IconNetwork,
  notepadText: IconNotepadText,
  paperclip: IconPaperclip,
  pause: IconPause,
  pencil: IconPencil,
  paypal: IconPaypal,
  paperPlane: IconPaperPlane,
  partyPopper: IconPartyPopper,
  percent: IconPercent,
  phone: IconPhone,
  piggyBank: IconPiggyBank,
  play: IconPlay,
  plug: IconPlug,
  plus: IconPlus,
  presentation: IconPresentation,
  printer: IconPrinter,
  puzzle: IconPuzzle,
  receiptEuro: IconReceiptEuro,
  receiptText: IconReceiptText,
  refresh: IconRefresh,
  refreshCwOff: IconRefreshCwOff,
  /* Keep this one named 'reorder' while old invoice editor is still used */
  /* Something royally messes up if 'reorder' in invoice-line-editor is renamed */
  reorder: IconGripVertical,
  repeat2: IconRepeat2,
  rotateSquare: IconRotateSquare,
  rocket: IconRocket,
  search: IconSearch,
  sendHorizontal: IconSendHorizontal,
  settings: IconSettings,
  share: IconShare,
  shield: IconShield,
  shoppingBag: IconShoppingBag,
  smartphone: IconSmartphone,
  sparkle: IconSparkle,
  sparkles: IconSparkles,
  sparkleOrbit: IconSparkleOrbit,
  squareArrowOutUpRight: IconSquareArrowOutUpRight,
  squareCheck: IconSquareCheck,
  squarePen: IconSquarePen,
  squarePlay: IconSquarePlay,
  star: IconStar,
  store: IconStore,
  target: IconTarget,
  textSelect: IconTextSelect,
  thumbsDown: IconThumbsDown,
  thumbsUp: IconThumbsUp,
  sunDim: IconSunDim,
  trash: IconTrash,
  triangleAlert: IconTriangleAlert,
  undo: IconUndo,
  unlink: IconUnlink,
  unplug: IconUnplug,
  upload: IconUpload,
  uploadCloud: IconUploadCloud,
  userLock: IconUserLock,
  userRound: IconUserRound,
  userStar: IconUserStar,
  usersRound: IconUsersRound,
  wallet: IconWallet,
  wrench: IconWrench,
  x: IconX,
  zap: IconZap,
  zoomIn: IconZoomIn,
  zoomOut: IconZoomOut,
}
